import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./authBase.service";

export const affiliateProductProgramsApi = createApi({
    reducerPath: 'product-programs',
    baseQuery: baseQueryWithAuth,
    tagTypes: ['Current'],
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
    endpoints: (builder) => ({
        getCurrentFile: builder.query({
            query: () => ({
                url: '/product-programs/current',
                method: 'GET',
            }),
            keepUnusedDataFor: 60,
            providesTags: ['Current']
        })
    })
})

export const {
    useGetCurrentFileQuery,
    util: { invalidateTags, resetApiState }
} = affiliateProductProgramsApi